import { Box } from "@chakra-ui/layout";
import { Container } from "components";
import { Stack, StackDivider } from "@chakra-ui/layout";
import { ProductPageSection } from "./ProductPageSection";

export const ProductPageBody = ({ children }) => {
  return (
    <Box py={20}>
      <Container>
        <Stack
          divider={<StackDivider borderColor="gray.150" />}
          spacing={{ base: 12, lg: 20 }}
        >
          {children}
        </Stack>
      </Container>
    </Box>
  );
};
